module.exports = __webpack_public_path__ + "assets/images/b2db91d1776a93292bca618d47c2cbfd.png";